var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar11 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 91,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-11_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDC500",
  d: "M90.334 45c0-24.853-20.147-45-45-45s-45 20.147-45 45 20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00CA69",
  d: "M57.614 10.575s3.443 13.564-11.148 18.585c0 0-2.787-16.024 11.148-18.585"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M45.045 29.486h.577c.665 0 1.204-.539 1.204-1.204V18.84c0-.665-.539-1.204-1.204-1.204h-.577c-.665 0-1.204.539-1.204 1.204v9.442c0 .665.54 1.204 1.204 1.204"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6651",
  d: "m22.976 34.451.007.015c2.599-4.968 8.07-8.396 14.397-8.396 2.898 0 5.617.72 7.96 1.976a16.8 16.8 0 0 1 7.962-1.976c6.322 0 11.786 3.416 14.389 8.378 0 0 6.739 11.418 1.29 24.483-3.011 8.543-12.454 14.775-23.64 14.775-11.19 0-20.636-6.24-23.644-14.786l-.011.011c-5.449-13.065 1.29-24.483 1.29-24.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E25344",
  d: "M65.775 55.867c.244-1.162.424-2.343.555-3.543.611-5.57-.071-11.284-2.7-16.29-2.602-4.962-7.56-8.82-13.882-8.82-1.163 0-2.295.116-3.387.337a16.9 16.9 0 0 1 6.942-1.474c6.322 0 11.786 3.417 14.388 8.378 0 0 6.74 11.419 1.287 24.484-2.948 7.068-9.068 12.277-16.643 13.837 1.871-.386 3.975-2.051 5.434-3.217 4.282-3.432 6.896-8.37 8.006-13.688z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.15 39.439a2.73 2.73 0 1 0 0-5.46 2.73 2.73 0 0 0 0 5.46"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-11_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.334 0h90v90h-90z"
})))));
export { SvgAvatar11 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-11.c947f3015514fdaeff63.svg";